'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeDonationTotals = exports.fetchDonationTotals = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _client = require('../../../utils/client');

var _client2 = _interopRequireDefault(_client);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _params = require('../../../utils/params');

var _campaigns = require('../../campaigns');

var _justgiving = require('../../feeds/justgiving');

var _currencies = require('../../../utils/currencies');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchDonationTotals = exports.fetchDonationTotals = function fetchDonationTotals() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  switch ((0, _params.dataSource)(params)) {
    case 'event':
      return Promise.all([(0, _justgiving.fetchDonations)(params), _client2.default.get('/v1/events/leaderboard', {
        eventid: Array.isArray(params.event) ? params.event.map(_params.getUID) : (0, _params.getUID)(params.event),
        currency: (0, _currencies.currencyCode)(params.country)
      }, {}, { paramsSerializer: _params.paramsSerializer })]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            feed = _ref2[0],
            totals = _ref2[1];

        return _extends({}, feed.meta, totals);
      });
    case 'charity':
      return _client2.default.get('donationsleaderboards/v1/totals', {
        charityIds: Array.isArray(params.charity) ? params.charity.map(_params.getUID) : (0, _params.getUID)(params.charity),
        currencyCode: (0, _currencies.currencyCode)(params.country)
      }, {}, { paramsSerializer: _params.paramsSerializer });
    default:
      var mapTotals = function mapTotals(data) {
        return _extends({}, data, {
          totalRaised: data.donationSummary.totalAmount - data.donationSummary.totalGiftAid,
          totalResults: data.donationSummary.totalNumberOfDonations
        });
      };

      return Array.isArray(params.campaign) ? Promise.all(params.campaign.map(_params.getUID).map(_campaigns.fetchCampaign)).then(function (campaigns) {
        return campaigns.map(mapTotals);
      }).then(function (campaigns) {
        return campaigns.reduce(function (acc, _ref3) {
          var totalRaised = _ref3.totalRaised,
              totalResults = _ref3.totalResults;
          return {
            totalRaised: acc.totalRaised + totalRaised,
            totalResults: acc.totalResults + totalResults
          };
        }, { totalRaised: 0, totalResults: 0 });
      }) : (0, _campaigns.fetchCampaign)((0, _params.getUID)(params.campaign)).then(mapTotals);
  }
};

var deserializeDonationTotals = exports.deserializeDonationTotals = function deserializeDonationTotals(totals) {
  return {
    raised: totals.totalRaised || totals.raisedAmount || (0, _get2.default)(totals, 'meta.totalAmount') || (0, _get2.default)(totals, 'donationSummary.totalAmount') || (0, _get2.default)(totals, 'totals.donationTotalAmount') || 0,
    offline: totals.offlineAmount || totals.raisedAmountOfflineInGBP || 0,
    donations: totals.totalResults || totals.numberOfDirectDonations || (0, _get2.default)(totals, 'donationSummary.totalNumberOfDonations') || (0, _get2.default)(totals, 'totals.donationCount') || 0
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/donation-totals/justgiving/index.js
// module id = 1315
// module chunks = 0